import classNames from 'classnames';
import { ReactNode } from 'react';
import DefaultButton, { DefaultButtonProps } from '../DefaultButton/DefaultButton';

interface IconButtonProps extends DefaultButtonProps {
  icon: ReactNode;
  title?: string;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
}

const IconButton = ({
  className,
  icon,
  title,
  tooltip,
  tooltipPosition = 'top',
  disabled,
  ...rest
}: IconButtonProps) => {
  const button = (
    <DefaultButton
      title={title}
      aria-label={title || tooltip}
      disabled={disabled}
      className={classNames('btn-square btn-sm text-gray-600', className)}
      {...rest}>
      {icon}
    </DefaultButton>
  );

  // If tooltip is provided, wrap button in tooltip span
  if (tooltip) {
    return (
      <span
        className={classNames('tooltip', `tooltip-${tooltipPosition}`)}
        data-tip={tooltip}>
        {button}
      </span>
    );
  }

  return button;
};

export default IconButton;
